import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../utils/isFlow';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getLoginUrl } from '../http-login/getLoginUrl';
import { getIsAuthenticated } from '../store/auth/selectors';
import { useTracker } from '../tracking/useTracker';
import { Step } from '../views/Step';
import { getLoginRedirectUrl } from './getLoginRedirectUrl';
import { StyledUILink } from '../views-components/TextInput.styles';

const getHaveAnAccountI18n = () => {
  return isFlow(Flow.Integrations) ? 'button.haveAnAccountIntegrations' : 'button.haveAnAccount';
};

export const HaveAnAccountLink = () => {
  const {
    currentStep
  } = useCurrentStep();
  const Tracker = useTracker();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const loginRedirectUrl = getLoginRedirectUrl();
  const shouldShowSignInButton = getFlowConfig().shouldShowSignInButton;

  const trackLoginClick = () => {
    Tracker.signupInteraction('click-login-have-an-account', {}, true);
    Tracker.redirect({
      url: 'https://app.hubspot.com/login'
    });
  };

  const shouldDiplayComponent = currentStep === Step.LandingPage && !isAuthenticated && shouldShowSignInButton;
  return shouldDiplayComponent ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: getHaveAnAccountI18n(),
    options: {
      link: /*#__PURE__*/_jsx(StyledUILink, {
        "data-selenium": "login",
        href: getLoginUrl({
          redirectUrl: loginRedirectUrl
        }),
        onClick: trackLoginClick,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "button.logIn"
        })
      }, "login-link")
    }
  }) : null;
};